
/* ===== INTEGRATION =====
   Paste your form endpoint (Formspree / Zapier / Google Apps Script / Sheet Monkey).
   POST receives JSON of all fields. Leave "" for an email fallback. */
const CONTEST_ENDPOINT = "https://script.google.com/macros/s/AKfycbyTS10gJCNBxOBMW-tmbFP-7brg1uDITp8oMCroH7oLJ-yeHMhCK8FJi1ZMn9kTamrb/exec"; /* Frost Lab dashboard backend */
const SHARE_URL        = "";  // optional: paste your live URL; blank = current page
const CONTACT_EMAIL    = "info@frostlab.us";

/* mini launch countdown (to August 31 — Grand Reveal round 2) */
const LAUNCH=new Date('2026-08-31T11:00:00-07:00').getTime();
function mtick(){const d=LAUNCH-Date.now(),el=document.getElementById('mc');if(!el)return;
  if(d<=0){el.textContent='live now';return}
  const D=Math.floor(d/864e5),H=Math.floor(d/36e5)%24,M=Math.floor(d/6e4)%60;
  el.textContent=D+'d '+String(H).padStart(2,'0')+'h '+String(M).padStart(2,'0')+'m';}
mtick();setInterval(mtick,30000);

let platform="";
const seg=document.getElementById('seg');
seg.querySelectorAll('button').forEach(b=>b.addEventListener('click',()=>{
  seg.querySelectorAll('button').forEach(x=>x.classList.remove('active'));
  b.classList.add('active');platform=b.dataset.p;
}));

const fmsg=document.getElementById('fmsg');
const val=id=>document.getElementById(id).value.trim();
document.getElementById('submit').addEventListener('click',async()=>{
  const data={formType:'contest',platform,firstName:val('fn'),lastName:val('ln'),email:val('em'),phone:val('ph'),
    handle:val('hd'),videoLink:val('vl'),guess:['002: '+(val('gs2')||'—'),'003: '+(val('gs3')||'—'),'004: '+(val('gs4')||'—')].join(' | ')};
  const agreed=document.getElementById('ag').checked;
  if(!platform){fmsg.className='fmsg err';fmsg.textContent='Pick a platform (TikTok or Instagram).';return}
  if(!data.firstName||!data.lastName||!data.email||!data.phone||!data.handle||!data.videoLink){
    fmsg.className='fmsg err';fmsg.textContent='Please fill in every field.';return}
  if(!val('gs2')&&!val('gs3')&&!val('gs4')){
    fmsg.className='fmsg err';fmsg.textContent='Guess at least one experiment — or all three for the grand prize.';return}
  if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(data.email)){fmsg.className='fmsg err';fmsg.textContent='Enter a valid email.';return}
  if(!agreed){fmsg.className='fmsg err';fmsg.textContent='Please agree to the Official Rules to enter.';return}
  fmsg.textContent='';fmsg.className='fmsg';document.getElementById('ag').checked=false;
  openModal();
  if(CONTEST_ENDPOINT){
    fetch(CONTEST_ENDPOINT,{method:'POST',mode:'no-cors',headers:{'Content-Type':'text/plain;charset=utf-8'},body:JSON.stringify(data)}).catch(function(){});
  }else{
    const body=encodeURIComponent(`Platform: ${data.platform}\nName: ${data.firstName} ${data.lastName}\nEmail: ${data.email}\nPhone: ${data.phone}\nHandle: ${data.handle}\nVideo: ${data.videoLink}\nGuess: ${data.guess}`);
    setTimeout(function(){window.location.href=`mailto:${CONTACT_EMAIL}?subject=Frost%20Lab%20Mystery%20Entry%20%E2%80%94%20${encodeURIComponent(data.firstName+' '+data.lastName)}&body=${body}`;},400);
  }
});
/* ===== share + copy link ===== */
(function(){
  var url=(typeof SHARE_URL!=="undefined" && SHARE_URL)?SHARE_URL:window.location.href;
  var text="Guess the first @frostlab.usa experiment to win $1,000! #frostlabmystery";
  var x=document.getElementById("xShare"); if(x){x.href="https://twitter.com/intent/tweet?text="+encodeURIComponent(text+" ")+"&url="+encodeURIComponent(url);}
  var wa=document.getElementById("waShare"); if(wa){wa.href="https://wa.me/?text="+encodeURIComponent(text+" "+url);}
  var sm=document.getElementById("shareMsg");
  function done(){sm.textContent="Link copied!";setTimeout(function(){sm.textContent="";},2500);}
  function fallback(){var t=document.createElement("textarea");t.value=url;document.body.appendChild(t);t.select();try{document.execCommand("copy");done();}catch(_){sm.textContent=url;}document.body.removeChild(t);}
  var copy=document.getElementById("copyBtn");
  if(copy){copy.addEventListener("click",function(){
    if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(url).then(done,fallback);}else{fallback();}
  });}
  var sh=document.getElementById("shareBtn");
  if(sh){if(navigator.share){sh.addEventListener("click",function(){navigator.share({title:"Frost Lab Mystery",text:text,url:url}).catch(function(){});});}else{sh.style.display="none";}}
})();

/* ===== thank-you modal control ===== */
function openModal(){var m=document.getElementById('modal');if(m)m.classList.add('show');}
function closeModal(){var m=document.getElementById('modal');if(m)m.classList.remove('show');}
document.addEventListener('click',function(e){
  var t=e.target;
  if(t.id==='modal'||(t.closest&&(t.closest('#modalClose')||t.closest('#modalX'))))closeModal();
});
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeModal();});

;

(function(){
  var END=new Date('2026-08-31T11:00:00-07:00').getTime();
  function ended(){
    if(Date.now()<END) return;
    if(document.getElementById('gvEnded')) return;
    var b=document.createElement('div'); b.id='gvEnded';
    var st=b.style;
    /* 2026-09-28: was sticky at z-index 500, so it pinned itself on top of the header as soon as you scrolled. It now sits at the top of the page and scrolls away, like every other bar on the site. */ st.position='relative'; st.zIndex='1';
    st.background='linear-gradient(90deg,rgba(127,233,255,.18),rgba(255,122,209,.2))';
    st.borderBottom='1px solid rgba(127,233,255,.35)';
    st.color='#eafdff'; st.fontFamily='Space Mono,monospace'; st.fontWeight='700';
    st.fontSize='.72rem'; st.letterSpacing='.14em'; st.textTransform='uppercase';
    st.textAlign='center'; st.padding='.8rem 1rem';
    b.textContent='\u2744 This giveaway has ended \u2014 get ready for the next one. Follow @frostlab.usa';
    document.body.insertBefore(b,document.body.firstChild);
    document.querySelectorAll('form input,form select,form textarea,form button,button[type=submit]').forEach(function(el){ el.disabled=true; });
    document.querySelectorAll('form').forEach(function(f){ f.addEventListener('submit',function(e){ e.preventDefault(); },true); });
  }
  ended(); setInterval(ended,30000);
})();

/* ---- universal double-submit guard (a real distributor lead came in twice) ---- */
(function(){
  document.addEventListener('submit', function(e){
    var f = e.target; if(!f || f.tagName !== 'FORM') return;
    var btn = f.querySelector('button[type="submit"], .submit, button:not([type="button"])');
    if(f.dataset.flBusy === '1'){ e.preventDefault(); e.stopImmediatePropagation(); return; }
    f.dataset.flBusy = '1';
    if(btn){ btn.disabled = true; var t = btn.textContent; btn.dataset.flTxt = t; btn.textContent = 'Sending\u2026'; }
    setTimeout(function(){
      f.dataset.flBusy = '';
      if(btn){ btn.disabled = false; if(btn.dataset.flTxt) btn.textContent = btn.dataset.flTxt; }
    }, 6000);
  }, true);
  /* same guard for button-driven (non-form) senders */
  ['join','submit'].forEach(function(id){
    var b = document.getElementById(id); if(!b || b.form) return;
    b.addEventListener('click', function(){
      if(b.dataset.flBusy === '1') return;
      b.dataset.flBusy = '1'; b.disabled = true;
      setTimeout(function(){ b.dataset.flBusy=''; b.disabled=false; }, 6000);
    });
  });
})();
